import _ from 'lodash'
import * as query from '@/queries/sales'
import utils from '@/store/utils'

const defaultState = function () {
  return {
    mode: 0, // 0: 通常, 1: 注文編集, 2: 交換出荷, 3: 返品登録
    returnList: false, // オペレーションボタンから編集モードに遷移したか
    tableSetList: [{}],
    tdLists: [],
    totalCount: 0,
    listIndex: -1,
    currentPage: 0,
    size: 10,
    isAndSearch: false,
    searchKeyword: '',
    searchKey: 'sales_list',
    maxGetCount: null,
    // 検索条件
    searchConditions: {},
    // 表示項目
    displayItems: []
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getters: {
    orderStatus () {
    },
    orderStatuses () {
    },
    orderStatusesByOrderId () {
    }
  },

  mutations: {
    // update (state, data) {
    //  state.tdLists = state.tdLists.map(t => {
    //    return t.node.site.code === data.node.site.code &&
    //            t.node.sku.code === data.node.sku.code &&
    //            t.node.stockType === data.node.stockType ? data : t
    //  })
    // }
    update (state, data) {
      const rowData = utils.pick(data, utils.createKeys(query.GRAPH_QL_QUERY_SALES_LIST, 3))
      _.chain(state.tdLists)
        .filter((value) => value.node.site.code === data.site.code && value.node.d_order.orderNo === data.d_order.orderNo)
        .forEach((val) => { val.node = rowData })
        .value()
    }
  },
  getDefaultState: defaultState
}
